import { useState } from 'react';
import { Icon } from 'src/components/ui/Icon';

const ErrorFallback = ({ error }) => {
  const [showStack, setShowStack] = useState(false);

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center theme-bg-primary theme-text-primary px-4 py-12">
      <div className="max-w-2xl w-full text-center space-y-4">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-red-500/10 border border-red-500/30 text-4xl text-red-500 mx-auto">
          <Icon name="exclamation-triangle" />
        </div>
        <h1 className="text-2xl font-bold theme-text-primary">Algo ha salido mal</h1>
        <em className="block theme-text-secondary not-italic">{error.message}</em>
        <button
          type="button"
          onClick={() => setShowStack(prev => !prev)}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-xl border theme-border bg-white dark:bg-zinc-900/50 hover:bg-zinc-50 dark:hover:bg-white/5 theme-text-primary text-sm transition-colors"
        >
          <Icon name={`chevron-${showStack ? 'up' : 'down'}`} />
          {showStack ? 'Ocultar stack trace' : 'Mostrar stack trace'}
        </button>
        {showStack && (
          <div className="text-left mx-auto max-w-3xl mt-4 p-4 rounded-2xl border theme-border bg-zinc-50 dark:bg-zinc-950/60 font-mono text-xs theme-text-secondary overflow-x-auto whitespace-pre">
            {(error.stack || '').split('\n').map((ln, i) => (
              <div key={i}>{ln}</div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorFallback;
